export default "__VITE_ASSET__Btj32uQj__"